module.exports = __webpack_public_path__ + "img/recommend_bg.794b6628.jpg";